import SessionMessage from './SessionMessage';

export default SessionMessage;